// extracted by mini-css-extract-plugin
export default {"Navbar":"Navigation_Navbar__0LCE0","NavTitle":"Navigation_NavTitle__gP163","Links":"Navigation_Links__odQvf","Title":"Navigation_Title__dPxsT"};